import {
  type GenericMappingByKey,
  GenericMappingType,
} from '../../search/types'
import { getGenericMappingArrayFromGenericMappingByKey } from './utils'

export const LINEAR_GENERIC_MAPPINGS_BY_KEY = Object.freeze({
  archivedAt: {
    type: GenericMappingType.DATE,
    name: 'Archival date',
    description: 'The date and time the issue was archived',
    order: 0,
  },
  assignee: {
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'Member assigned to the issue',
    enumFromCollapseEsQuery: true,
    order: 1,
  },
  canceledAt: {
    type: GenericMappingType.DATE,
    name: 'Cancellation date',
    description: 'The date and time the issue was cancelled',
    order: 2,
  },
  completedAt: {
    type: GenericMappingType.DATE,
    name: 'Completion date',
    description: 'The date and time the issue was completed',
    order: 3,
  },
  dueDate: {
    type: GenericMappingType.DATE,
    name: 'Due date',
    description: 'The due date of the issue',
    order: 4,
  },
  creator: {
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'The user who created the issue',
    enumFromCollapseEsQuery: true,
    order: 5,
  },
  estimate: {
    type: GenericMappingType.NUMBER,
    name: 'Estimate',
    description: 'Number to estimate the complexity of the issue',
    order: 6,
  },
  labels: {
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the issue',
    enumFromTermsAggEsQuery: true,
    order: 7,
  },
  priority: {
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'The priority of the issue',
    enum: ['No priority', 'Low', 'Medium', 'High'],
    order: 8,
  },
  state: {
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'The state of the issue',
    enumFromCollapseEsQuery: true,
    order: 9,
  },
  cycle: {
    type: GenericMappingType.KEYWORD,
    name: 'Cycle',
    description: 'The cycle name the issue is associated with',
    enumFromCollapseEsQuery: true,
    order: 10,
  },
  cycleNumber: {
    type: GenericMappingType.NUMBER,
    name: 'Cycle number',
    description:
      'The numeric cycle representation the issue is associated with',
    order: 11,
  },
  identifier: {
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable issue identifier',
    order: 12,
  },
  team: {
    type: GenericMappingType.KEYWORD,
    name: 'Team',
    description: 'The team the issue is associated with',
    enumFromCollapseEsQuery: true,
    order: 13,
  },
  project: {
    type: GenericMappingType.KEYWORD,
    name: 'Project',
    description: 'The project the issue is associated with',
    enumFromCollapseEsQuery: true,
    order: 14,
  },
} satisfies GenericMappingByKey)

export const LINEAR_GENERIC_MAPPINGS =
  getGenericMappingArrayFromGenericMappingByKey(LINEAR_GENERIC_MAPPINGS_BY_KEY)
